<script>
	// pluck css from reusable content blocks and post into head
	export default {
		name: "custom-css",
		data: () => ({
			styles: "",
		}),
		props: {
			styles: {
				Type: String,
			},
		},
		mounted() {
			const customCssBlock = this.styles;
			if (!customCssBlock) return;

			this.$customCss = document.createElement("style");
			this.$customCss.appendChild(document.createTextNode(customCssBlock));
			document.head.appendChild(this.$customCss);
		},
		destroyed() {
			if (this.$customCss) {
				this.$customCss.remove();
			}
		},
	};
</script>
